import { useState } from "react";
import StyledTable, { ColumnHeader } from "../../../../components/table/styled-table";
import MealItemTableRow from "./meal-item-table-row";
import { configs } from "../../../../app/app-configs";
import { MealItem } from "../../../../service/model/nutrition.model";

const headers: ColumnHeader[] = [
    { name: "Name" },
    // { name: "Category" },
    { name: "Quantity" },
    // { name: "Unit" },
    { name: "Calories (cal)" },
    { name: "Protein (g)" },
    { name: "Carbs (g)" },
    { name: "Fat (g)" },
    { name: "Fiber (g)" },
    { name: "Sugar (g)" },
    { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly mealItems: MealItem[]
}

const MealItemTable: React.FC<TableProps> = ({ mealItems }) => {

    const [page, setPage] = useState(1);

    const pageCount = Math.ceil(mealItems.length / configs.PAGE_SIZE);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <StyledTable headers={headers}
            currentPage={page}
            totalPages={pageCount}
            onPageChange={handlePageChange}>

            {(configs.PAGE_SIZE > 0
                ? mealItems.slice((page - 1) * configs.PAGE_SIZE, (page - 1) * configs.PAGE_SIZE + configs.PAGE_SIZE)
                : mealItems
            )?.map(item =>
                <MealItemTableRow mealItem={item} key={item.id} />
            )}
        </StyledTable>
    );
}

export default MealItemTable;